<template>
  <aside class="menu">
    <RouterLink to="/" class="border-bottom menu__header">
      <img src="/logo.svg" alt="Logo" class="logo">
    </RouterLink>
    <nav>
      <ul class="menu__list">
        <li v-for="item of items" :key="item.title">
          <div
            class="menu__parent"
            :class="{
              open: item.isOpen,
              active:
                !!hasActiveChildren(item.title)
                || (!item.children.length && $route.path === item.to),
            }"
            @click="toggleIsOpen(item.title)"
          >
            <RouterLink
              v-if="!item.children.length"
              :to="item.to || '/'"
              class="menu__parent-link"
            >
              {{ item.title }}
            </RouterLink>
            <span v-else>{{ item.title }}</span>
            <SvgIcon
              v-if="!!item.children.length"
              :icon="item.isOpen ? 'chevron-down' : 'chevron-right'"
              class="menu__parent-chevron"
            />
          </div>
          <ul v-show="item.isOpen" class="menu__children">
            <li v-for="child of item.children" :key="child.title">
              <RouterLink
                :to="child.path"
                :class="{ 'router-link-active': $route.path === child.path }"
                class="menu__child"
              >
                {{ child.title }}
              </RouterLink>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  </aside>
</template>

<script lang="ts" src="./ApiDocsMenuComponent.ts"></script>

<style scoped lang="scss" src="./ApiDocsMenuComponent.scss"></style>
